import { render, staticRenderFns } from "./AddPatientModal.vue?vue&type=template&id=7517c760"
import script from "./AddPatientModal.vue?vue&type=script&lang=js"
export * from "./AddPatientModal.vue?vue&type=script&lang=js"
import style0 from "./AddPatientModal.vue?vue&type=style&index=0&id=7517c760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports